import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { BrandMark } from '@/components/layout/BrandMark';

/** Route guard — sends unauthenticated users to /login, preserving where they were headed. */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-dvh grid place-items-center">
        <div className="flex flex-col items-center gap-4 text-muted">
          <BrandMark size={42} />
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase">Authenticating…</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    return <Navigate to="/login" state={{ from: returnTo }} replace />;
  }

  return <Outlet />;
}
